import { render, staticRenderFns } from "./text-popup.vue?vue&type=template&id=18f72b10&scoped=true&"
import script from "./text-popup.vue?vue&type=script&lang=ts&"
export * from "./text-popup.vue?vue&type=script&lang=ts&"
import style0 from "./text-popup.vue?vue&type=style&index=0&id=18f72b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f72b10",
  null
  
)

export default component.exports